export default {
  GETTERS: {
    GET_PRODUCT: 'PRODUCT/GET_PRODUCT',
    GET_PRODUCT_ID: 'PRODUCT/GET_PRODUCT_ID',
    GET_PRODUCT_BRAND: 'PRODUCT/GET_PRODUCT_BRAND',
    GET_BRAND_HREF: 'PRODUCT/GET_BRAND_HREF',
    GET_IS_FLASH_SALE: 'PRODUCT/GET_IS_FLASH_SALE',
    GET_LISTED_PRICE: 'PRODUCT/GET_LISTED_PRICE',
    GET_SALE_PRICE: 'PRODUCT/GET_SALE_PRICE',
    GET_TAG_TEXT: 'PRODUCT/GET_TAG_TEXT',
    GET_PRICE_SUBTITLE: 'PRODUCT/GET_PRICE_SUBTITLE',
    GET_TIMER_TEXT: 'PRODUCT/GET_TIMER_TEXT',
    GET_TIMER_TYPE: 'PRODUCT/GET_TIMER_TYPE',
    GET_EXPIRES_AT: 'PRODUCT/GET_EXPIRES_AT',
    GET_COLOR: 'PRODUCT/GET_COLOR',
    GET_HAS_PENDING_CHECKOUT: 'PRODUCT/GET_HAS_PENDING_CHECKOUT',
    GET_IS_PURCHASE_AVAILABLE: 'PRODUCT/GET_IS_PURCHASE_AVAILABLE',
    GET_IS_OFFER_AVAILABLE: 'PRODUCT/GET_IS_OFFER_AVAILABLE',
    GET_CAN_SELL_WITH_BUNDLE: 'PRODUCT/GET_CAN_SELL_WITH_BUNDLE',
    GET_OFFER: 'PRODUCT/GET_OFFER',
    GET_OFFER_STATUS: 'PRODUCT/GET_OFFER_STATUS',
    GET_UNAVAILABLE_REASON: 'PRODUCT/GET_UNAVAILABLE_REASON',
    GET_IS_HAND_DELIVER: 'PRODUCT/GET_IS_HAND_DELIVER',
    GET_IS_PRODUCT_IN_BUNDLE: 'PRODUCT/GET_IS_PRODUCT_IN_BUNDLE',
    GET_RELEASE_TO_BUY_AT: 'PRODUCT/GET_RELEASE_TO_BUY_AT',
    GET_MORE_FROM_STORE: 'PRODUCT/GET_MORE_FROM_STORE',
    GET_RELATED_PRODUCTS: 'PRODUCT/GET_RELATED_PRODUCTS',
    GET_NAVIGATION_HISTORY: 'PRODUCT/GET_NAVIGATION_HISTORY',
    GET_CURRENT_USER_ID: 'PRODUCT/GET_CURRENT_USER_ID',
    GET_IS_FETCHING_PRICE: 'PRODUCT/GET_IS_FETCHING_PRICE',
    GET_PURCHASE_STATE: 'PRODUCT/GET_PURCHASE_STATE',
    GET_IS_BANKSLIP_AVAILABLE: 'PRODUCT/GET_IS_BANKSLIP_AVAILABLE',
    GET_IS_PIX_AVAILABLE: 'PRODUCT/GET_IS_PIX_AVAILABLE',
    GET_PAYMENT_OPTIONS_DESCRIPTION: 'PRODUCT/GET_PAYMENT_OPTIONS_DESCRIPTION',
    GET_IS_READY: 'PRODUCT/GET_IS_READY',
    GET_IS_PRODUCT_OWNER: 'PRODUCT/GET_IS_PRODUCT_OWNER',
    GET_HAS_FILLED_META_TAGS: 'PRODUCT/GET_HAS_FILLED_META_TAGS',
    GET_SHIPPING: 'PRODUCT/GET_SHIPPING',
    GET_IS_SHIPPING_PRICE_ENABLE: 'PRODUCT/GET_IS_SHIPPING_PRICE_ENABLE',
    GET_COUPON: 'PRODUCT/GET_COUPON',
    GET_HAS_COPIED_COUPON_CODE: 'PRODUCT/GET_HAS_COPIED_COUPON_CODE',
    GET_SIMILAR_PRODUCT_CONTENT: 'PRODUCT/GET_SIMILAR_PRODUCT_CONTENT',
    GET_IS_FETCHING_ACTIONS: 'PRODUCT/GET_IS_FETCHING_ACTIONS',
    GET_PRODUCT_ACTIONS: 'PRODUCT/GET_PRODUCT_ACTIONS',
    GET_PRODUCT_BANNER: 'PRODUCT/GET_PRODUCT_BANNER',
    GET_SHOW_BUNDLE_SUGGESTION_MODAL: 'PRODUCT/GET_SHOW_BUNDLE_SUGGESTION_MODAL',
    GET_SERVICE_TAX: 'PRODUCT/GET_SERVICE_TAX',
    GET_RELATED_PRODUCT_SEARCH_ID: 'PRODUCT/GET_RELATED_PRODUCT_SEARCH_ID',
    GET_MORE_FROM_STORE_SEARCH_ID: 'PRODUCT/GET_MORE_FROM_STORE_SEARCH_ID',
    GET_CROSS_SELL_METRIC_DATA: 'PRODUCT/GET_CROSS_SELL_METRIC_DATA'
  },
  MUTATIONS: {
    SET_PRODUCT: 'PRODUCT/SET_PRODUCT',
    SET_OFFER: 'PRODUCT/SET_OFFER',
    SET_PURCHASE: 'PRODUCT/SET_PURCHASE',
    SET_REGULAR_PRICE: 'PRODUCT/SET_REGULAR_PRICE',
    SET_TIMER_PRICE: 'PRODUCT/SET_TIMER_PRICE',
    SET_STORE_PRODUCTS_PATH: 'PRODUCT/SET_STORE_PRODUCTS_PATH',
    SET_RELATED_PRODUCTS_PATH: 'PRODUCT/SET_RELATED_PRODUCTS_PATH',
    SET_NAVIGATION_HISTORY_PATH: 'PRODUCT/SET_NAVIGATION_HISTORY_PATH',
    SET_OWNER_ID: 'PRODUCT/SET_OWNER_ID',
    SET_FALLBACK_PRICING: 'PRODUCT/SET_FALLBACK_PRICING',
    SET_STORE_ID: 'PRODUCT/SET_STORE_ID',
    SET_MORE_FROM_STORE: 'PRODUCT/SET_MORE_FROM_STORE',
    SET_IS_FETCHING_MORE_FROM_STORE: 'PRODUCT/SET_IS_FETCHING_MORE_FROM_STORE',
    SET_IS_FLASH_SALE: 'PRODUCT/SET_IS_FLASH_SALE',
    SET_RELATED_PRODUCTS: 'PRODUCT/SET_RELATED_PRODUCTS',
    SET_NAVIGATION_HISTORY: 'PRODUCT/SET_NAVIGATION_HISTORY',
    SET_CURRENT_USER_ID: 'PRODUCT/SET_CURRENT_USER_ID',
    SET_IS_FETCHING_PRICE: 'PRODUCT/SET_IS_FETCHING_PRICE',
    SET_IS_READY: 'PRODUCT/SET_IS_READY',
    SET_VARIATIONS: 'PRODUCT/SET_VARIATIONS',
    SET_HAS_FILLED_META_TAGS: 'PRODUCT/SET_HAS_FILLED_META_TAGS',
    SET_SHIPPING: 'PRODUCT/SET_SHIPPING',
    SET_IS_SHIPPING_PRICE_ENABLE: 'PRODUCT/SET_IS_SHIPPING_PRICE_ENABLE',
    SET_COUPON: 'PRODUCT/SET_COUPON',
    SET_HAS_COPIED_COUPON_CODE: 'PRODUCT/SET_HAS_COPIED_COUPON_CODE',
    SET_SERVICE_TAX: 'PRODUCT/SET_SERVICE_TAX',
    SET_SIMILAR_PRODUCT_INFO: 'PRODUCT/SET_SIMILAR_PRODUCT_INFO',
    SET_PRODUCT_ACTIONS: 'PRODUCT/SET_PRODUCT_ACTIONS',
    SET_PRODUCT_BANNER: 'PRODUCT/SET_PRODUCT_BANNER',
    SET_IS_FETCHING_ACTIONS: 'PRODUCT/SET_IS_FETCHING_ACTIONS',
    SET_SHOW_BUNDLE_SUGGESTION_MODAL: 'PRODUCT/SET_SHOW_BUNDLE_SUGGESTION_MODAL',
    SET_RELATED_PRODUCT_SEARCH_ID: 'PRODUCT/SET_RELATED_PRODUCT_SEARCH_ID',
    SET_MORE_FROM_STORE_SEARCH_ID: 'PRODUCT/SET_MORE_FROM_STORE_SEARCH_ID'
  },
  ACTIONS: {
    LOAD: 'PRODUCT/LOAD',
    LOAD_MORE_FROM_STORE: 'PRODUCT/LOAD_MORE_FROM_STORE',
    LOAD_PRODUCT_DATA: 'PRODUCT/LOAD_PRODUCT_DATA',
    LOAD_PRODUCT_ACTIONS: 'PRODUCT/LOAD_PRODUCT_ACTIONS',
    LOAD_RELATED_PRODUCTS: 'PRODUCT/LOAD_RELATED_PRODUCTS',
    LOAD_NAVIGATION_HISTORY: 'PRODUCT/LOAD_NAVIGATION_HISTORY',
    LOAD_SHIPPING_PRICE: 'PRODUCT/LOAD_SHIPPING_PRICE',
    LOAD_SIMILAR_PRODUCT_INFO: 'PRODUCT/LOAD_SIMILAR_PRODUCT_INFO'
  }
}
